import { faqs } from './faqs';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'hooks/useTranslation';
import { FaqsList } from './FaqsList';

export const FAQsSection = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ padding: { xs: '40px 0', lmd: '100px 0 120px' }, backgroundColor: '#F6F8FC' }}>
            <Box sx={{ maxWidth: '1016px', margin: { xs: '0 20px', lmd: '0 auto' } }}>
                <Typography
                    variant="h2Bold"
                    sx={{
                        fontSize: '28px',
                        color: 'text.black',
                        marginBottom: '4px',
                    }}
                >
                    {t('Frequently Asked')}
                </Typography>
                <Typography
                    variant="h2Bold"
                    sx={{
                        fontSize: '38px',
                        background: 'linear-gradient(165deg, #0A2693 0%, #01CFFE 25%, #F2D3CD 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        display: 'block',
                        mb: { xs: '32px', lmd: '52px' },
                        width: 'fit-content',
                    }}
                >
                    {t('Questions')}
                </Typography>
                <Stack
                    sx={{
                        flexDirection: { xs: 'column', lmd: 'row' },
                        gap: { xs: '24px', lmd: '40px' },
                        maxHeight: { xs: '70vh', lmd: 'unset' },
                        overflowY: { xs: 'auto', lmd: 'unset' },
                        pr: { xs: '9px', lmd: 0 },
                        '&::-webkit-scrollbar': {
                            width: '9px',
                            backgroundColor: 'background.white',
                            borderRadius: '8px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: 'linear-gradient(135deg, #0A2693 0%, #01CFFE 96.22%)',
                            borderRadius: '8px',
                        },
                    }}
                >
                    <FaqsList faqs={faqs.slice(0, Math.ceil(faqs.length / 2))} />
                    <FaqsList faqs={faqs.slice(Math.ceil(faqs.length / 2))} />
                </Stack>
            </Box>
        </Box>
    );
};
